import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable()
export class CoreService extends BaseHttpService {

    private rootUrl: string = 'core';
    isSavedSubject: Subject<void> = new Subject<void>();
    isSavedObservable = this.isSavedSubject.asObservable();

    fetch(brandId: string): Observable<any> {
        return this.http.get(Config.API + '/' + this.rootUrl + '/' + brandId)

            .pipe(catchError(this.handleError.bind(this)));
    }

    put(brandId: string, data: any): Observable<any> {
      const body = JSON.stringify({ data });
      return this.http.put(Config.API + '/' + this.rootUrl + '/' + brandId, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }
    emitIsSaved() {
      this.isSavedSubject.next();
    }
}
